module.exports = __webpack_public_path__ + "img/illusThrones.7424c5fd.jpg";